import { camelCase } from 'lodash';

// input:
//  {
//   'FirstName': 'John',
//   'LastName': 'Smith',
//   'BirthDate': new Date(),
//   'ArrayTest': ['one', 'TWO', 3],
//   'ThisKey': {
//     'This-Sub-Key': 42
//   }
// }

// output
// {
//   "firstName": "John",
//   "lastName": "Smith",
//   "birthDate": "2018-05-31T09:03:57.844Z",
//   "arrayTest":[
//      "one",
//      "TWO",
//      3
//   ],
//   "thisKey":{
//      "thisSubKey": 42
//   }
// }

export const toCamelCase = obj => {
  if (Array.isArray(obj)) {
    return obj.map(v => toCamelCase(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: toCamelCase(obj[key])
      }),
      {}
    );
  }
  return obj;
};
